<template>
  <h3 class="title mt-3 mb-4 text-center">Personal info</h3>
  <h6 class="title mt-3 mb-4 text-center">
    Manage your info.
  </h6>
  <!-- Account info -->
  <div class="row mb-4">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 rounded-3">
      <a class="list-group-item border-bottom-0 text-dark disabled">
        <div class="col">
          <h4 class="title">Account info</h4>
          Some info may be visible to other people using the service.
        </div>
      </a>
      <button
        class="list-group-item list-group-item-action"
        @click="goAccount()"
      >
        <table class="table align-middle" style="height: 150px">
          <colgroup>
            <col style="width: 50%" />
          </colgroup>
          <tbody>
          <tr class="border-bottom">
            <th>FULL NAME</th>
            <td>{{ user.FIRST_NAME }}, {{ user.LAST_NAME }}</td>
          </tr>
          <tr class="border-bottom">
            <th>EMAIL</th>
            <td>{{ user.EMAIL }}</td>
          </tr>
          <tr>
            <th>USERNAME</th>
            <td>{{ user.USER_ID }}</td>
          </tr>
          </tbody>
        </table>
      </button>
      <button
        class="list-group-item list-group-item-action d-flex justify-content-end"
        @click="goAccount()"
      >
        <div class="mt-2 mb-2">
          <b>Manage your account info</b>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="23"
            fill="currentColor"
            class="bi bi-pencil-square"
            viewBox="0 0 16 16"
          >
            <path
              d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
            />
            <path
              fill-rule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
            />
          </svg>
        </div>
      </button>
    </div>
    <div class="col-sm-3"></div>
  </div>
  <!-- Basic info -->
  <!-- <div class="row mb-4">
    <div class="col-sm-3"></div>
    <div class="col-sm-6 rounded-3">
      <a class="list-group-item border-bottom-0 text-dark disabled">
        <div class="col">
          <h4 class="title">Basic info</h4>
          Some info may be visible to other people using Dot services.
        </div>
      </a>
      <button
        class="list-group-item list-group-item-action"
        @click="goBasicEdit()"
      >
        <table class="table align-middle" style="height: 300px">
          <colgroup>
            <col style="width: 50%" />
          </colgroup>
          <tbody>
          <tr class="border-bottom">
            <th>NICKNAME</th>
            <td>{{ user.NICK_NAME }}</td>
          </tr>
          <tr class="border-bottom">
            <th>SEX</th>
            <td>{{ user.SEX_TYPE }}</td>
          </tr>
          <tr class="border-bottom">
            <th>MOBILE</th>
            <td>{{ user.MOBILE }}</td>
          </tr>
          <tr class="border-bottom">
            <th>TEL</th>
            <td>{{ user.TEL }}</td>
          </tr>
          <tr class="border-bottom">
            <th>BIRTHDAY</th>
            <td>{{ user.BIRTH_TYPE }} {{ user.BIRTH_DAY }}</td>
          </tr>
          <tr>
            <th>ADDRESS</th>
            <td>{{ user.ZIP_CODE }} {{ user.ADDR1 }} {{ user.ADDR2 }}</td>
          </tr>
          </tbody>
        </table>
      </button>
      <button
        class="list-group-item list-group-item-action d-flex justify-content-end"
        @click="goBasicEdit()"
      >
        <div class="mt-2 mb-2">
          <b>Manage your basic info</b>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="35"
            height="23"
            fill="currentColor"
            class="bi bi-pencil-square"
            viewBox="0 0 16 16"
          >
            <path
              d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
            />
            <path
              fill-rule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
            />
          </svg>
        </div>
      </button>
    </div>
    <div class="col-sm-3"></div>
  </div> -->
  <!-- Password & Delete Account -->
  <div class="row mb-4">
    <div class="col-sm-3"></div>
    <div class="col-sm-6">
      <div class="row">
        <!-- Delete Account -->
        <div class="col-sm-6 rounded-3 mb-4">
          <a class="list-group-item border-bottom-0 text-dark disabled">
            <div class="col">
              <h4 class="title">Password</h4>
              A secure password helps protect your account
            </div>
          </a>
          <button
            class="list-group-item list-group-item-action"
            @click="goResetPwd()"
          >
            <table class="table align-middle" style="height: 150px">
              <colgroup>
                <col style="width: 50%" />
              </colgroup>
              <tbody>
              <tr>
                <th>PASSWORD</th>
                <td>********</td>
              </tr>
              </tbody>
            </table>
          </button>
          <button
            class="list-group-item list-group-item-action d-flex justify-content-end"
            @click="goResetPwd()"
          >
            <div class="mt-2 mb-2">
              <b>Manage your password</b>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="23"
                fill="currentColor"
                class="bi bi-pencil-square"
                viewBox="0 0 16 16"
              >
                <path
                  d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                />
                <path
                  fill-rule="evenodd"
                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                />
              </svg>
            </div>
          </button>
        </div>

        <!-- Delete Account -->
        <div class="col-sm-6 rounded-3 mb-4">
          <a class="list-group-item border-bottom-0 text-dark disabled">
            <div class="col">
              <h4 class="title">Delete Account</h4>
              Your account and all its data will be deleted
            </div>
          </a>
          <button
            class="list-group-item list-group-item-action"
            @click="goDelete()"
          >
            <table class="table align-middle" style="height: 150px">
              <colgroup>
                <col style="width: 33%" />
              </colgroup>
              <tbody>
              <tr>
                <th>NOTE:</th>
                <td>This action cannot be undone</td>
              </tr>
              </tbody>
            </table>
          </button>
          <button
            class="list-group-item list-group-item-action d-flex justify-content-end"
            @click="goDelete()"
          >
            <div class="mt-2 mb-2">
              <b>Delete your account</b>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="23"
                fill="currentColor"
                class="bi bi-pencil-square"
                viewBox="0 0 16 16"
              >
                <path
                  d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                />
                <path
                  fill-rule="evenodd"
                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                />
              </svg>
            </div>
          </button>
        </div>
      </div>
    </div>
    <div class="col-sm-3"></div>
  </div>
</template>
<script>
import { $global, $axios, $error } from "@/dot-ui/index.js";
import { router } from "@/router/index.js";

export default {
  data() {
    return {
      user: {
        USER_NO: localStorage.getItem("_USER_NO_"),
        USER_ID: localStorage.getItem("_USER_ID_"),
        FIRST_NAME: "",
        LAST_NAME: "",
        NICK_NAME: "",
        USER_TYPE: "",
        MOBILE: "",
        BIRTH_DAY: "",
        BIRTH_TYPE: "",
        SEX_TYPE: "",
        ZIP_CODE: "",
        ADDR1: "",
        ADDR2: "",
        TEL: "",
        AREA: "",
        EMAIL: "",
      },
      fromParams: "",
    };
  },
  created() {
    this.fromParams = $global.getUrlParams();
  },
  mounted() {
    this.search();
  },
  methods: {
    async search() {
      let fromSiteNo = this.fromParams.s;
      let fromCompNo = this.fromParams.c;
      let url =
        "/user-app/v1/sites/" +
        fromSiteNo +
        "-" +
        fromCompNo +
        "/users/" +
        this.user.USER_NO;
      let response = await $axios.get(url);

      if (response.status == 200) {
        let json = response.data;
        this.user = json;
      } else {
        $error.showMessage(response, this);
      }
    },
    goDelete() {
      router.push({
        path: "/delete",
        query: {
          cb: this.fromParams.cb,
          s: this.fromParams.s,
          c: this.fromParams.c,
        },
      });
    },
    goAccount() {
      router.push({
        path: "/editAccount",
        query: {
          cb: this.fromParams.cb,
          s: this.fromParams.s,
          c: this.fromParams.c,
        },
      });
    },
    goBasicEdit() {
      router.push({
        path: "/Edit",
        query: {
          cb: this.fromParams.cb,
          s: this.fromParams.s,
          c: this.fromParams.c,
        },
      });
    },
    goResetPwd() {
      router.push({
        path: "/resetPwd",
        query: {
          cb: this.fromParams.cb,
          s: this.fromParams.s,
          c: this.fromParams.c,
        },
      });
    },
  },
};
</script>
<style></style>
